<template>
  <div
    v-if="value && value.max && value.series"
    class="statistics__measure"
    ref="measure">
  </div>
  <div
    v-else
    :key="emptyKey"
    class="dashboard-empty__container">
    <i class="iconfont icon-nodata"></i>
    <div>暂无数据</div>
  </div>
</template>

<script>
  // 计量图
  import {clone} from "../../../../assets/js/Untis"
  import current from "./mixin"

  export default {
    mixins: [current],
    data() {
      return {
        emptyKey: Math.random(),
        optConf: {
          color: [],
          tooltip: {
            show: false
          },
          series: null, /*[

            {
              type: 'gauge',
              id: 'dataId',
              min: 0,
              max: 1000,
              axisLine: {}, // 坐标轴线.设置仪表盘宽度，颜色
              pointer: {}, // 指针配置
              axisLabel: {},
              axisTick: { // 坐标轴小标记
                show: false
              },
               splitLine: { // 分隔线
                show: false
              },
              title: {},
              detail: {},
              data: [{value: 50, name: '完成率'}],
            }

          ]*/
        },
        chart: null,
        loaded: false,
      }
    },
    mounted() {
        if (this.$refs.measure) {
          const chart = this.$ECharts.init(this.$refs.measure)
          chart.title = ''
          this.chart = chart
          this.initChart()
        }

    },
    methods: {
      // 重新初始化图表 父级可调用
      initChart() {
        this.$nextTick(() => {
          if (!this.chart && this.$refs.measure) {
            const chart = this.$ECharts.init(this.$refs.measure)
            chart.title = ''
            this.chart = chart
          }
          if (this.value && this.chart) {
            const opt = clone(this.optConf)
            opt.color = this.showPropertiesHolder.theme.value
            const showFieldsColor = this.showPropertiesHolder.showFieldsColor
            const colors = this.showPropertiesHolder.colors
            const propertiesSetting = this.chartPropertiesHolder.propertiesSetting
            const value = this.value

            if (value && value.max && value.series) {

              // 如果图标设置中设置了max，并且是固定值，这里的max就使用设置的值
              let max = value.max.value
              if (propertiesSetting.valueType === 'FIXED' && propertiesSetting.value) {
                max = Number(propertiesSetting.value)
              }

              let name = (value.series.value / max * 100).toFixed(propertiesSetting.prec) + '%'

              // 设置颜色
              let realColor = ''
              const dataValue = value.series.value / max * 100
              if (colors) {
                for(let i = 0; i < colors.length; i++) {
                  const item = colors[i]
                  if (item.type === 'range') {
                    if (item.values[0] <= dataValue && dataValue <= item.values[1]) {
                      realColor = item.color
                      break
                    }
                  } else if (item.type === 'eq') {
                    if (item.value === dataValue) {
                      realColor = item.color
                      break
                    }
                  } else if (item.type === 'gt') {
                    // 大于
                    if (item.value < dataValue) {
                      realColor = item.color
                      break
                    }
                  } else if (item.type === 'lt') {
                    // 小于
                    if (item.value > dataValue) {
                      realColor = item.color
                      break
                    }
                  }
                }
              } else {
                realColor = '#63B2EE'
              }
              let color = [
                [value.series.value / max, realColor],
                [1, '#DCDDDD'],
              ]
              if (max === 0) {
                name = ''
                color = [
                  [0, '#63B2EE'],
                  [1, '#DCDDDD'],
                ]
              }

              const realName = propertiesSetting.title ? propertiesSetting.title : value.series.name
              const unit = propertiesSetting.unit ? `(${propertiesSetting.unit})` : ''

              opt.series = {
                type: 'gauge',
                id: value.series.dataId,
                min: 0,
                max: max,
                axisLine: { // 坐标轴线
                  lineStyle: { // 属性lineStyle控制线条样式
                    color,
                    width: 50, //半径
                    shadowColor: '#fff', //默认透明
                    shadowBlur: 1
                  }
                },
                pointer: {
                  show: true,
                  length: '30%',
                  width: 20
                },
                axisLabel: {
                  show: true,
                  distance: -50,
                  formatter: function (value) {
                    return value;
                  }
                },
                axisTick: { // 坐标轴小标记
                  show: false
                },
                splitLine: { // 分隔线
                  show: false
                },
                title: {
                  textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                    fontWeight: 'bolder',
                    fontStyle: 'italic',
                    color: '#000',
                    shadowColor: '#fff', //默认透明
                    shadowBlur: 10,
                    fontSize: 30,
                  }
                },
                detail: { //show : true ,
                  borderColor: '#fff',
                  shadowColor: '#fff', //默认透明
                  textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                    fontWeight: 'bolder',
                    fontSize: 20,
                    color: '#000'
                  },
                  formatter: value => {
                    //
                    return realName + '\n' + Number(value).toLocaleString() + unit
                  }
                },

                data: [
                  {
                    value: value.series.value,
                    name: name,
                    realName: realName,
                    realValue: value.series.value
                  }
                ]
              }
              this.chart.setOption(opt, true, false, true)
              this.resize()
            } else {
              this.chart.clear()
              this.emptyKey = Math.random()
              this.chart = null
            }
          }
        })
      },
      // 重置或初始化图表实例
      resize() {
        this.$nextTick(() => {
          if (this.chart) {
            this.chart.resize()
          }
        })
      }
    },
    watch: {
      // value 发生修改时 重新渲染图表
      value() {
        this.initChart()
      }
    }
  }
</script>

<style rel="stylesheet" lang="less">
  .statistics__measure {
    width: 100%;
    height: 100%;
    position: relative;
  }
</style>
